// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"BannerTop_thecomp__i7gXd"};